import React from 'react';
import {
    Modal,
    TextField,
    Icon,
    ResourceItem,
    ResourceList,
    TextStyle,
    Stack,
    Thumbnail,
    Button
} from '@shopify/polaris';
import {
    SearchMinor
} from '@shopify/polaris-icons';
import Cookies from "js-cookie";

function handleProductItemClick(e, id) {
    const shopOrigin = Cookies.get("shopOrigin");
    window.open(`https://${shopOrigin}/admin/products/${id}`, '_blank');
}

class SelectProductsModal extends React.Component {

    state = {
        selectedProducts: [],
        searchText: ""
    };

    constructor(props) {
        super(props);

        this.state = {
            selectedProducts: props.selectedTags != null ? props.selectedProducts : []
        }
    }

    render() {

        return <Modal
            open={this.props.active}
            onClose={this.props.onCancel}
            title="Choose products (max 3)"
            primaryAction={{
                content: 'Done',
                onAction: this.onDone,
            }}
            secondaryActions={[{
                content: 'Cancel',
                onAction: this.props.onCancel,
            }]}
        >
            <Modal.Section>
                <TextField
                    value={this.state.searchText}
                    placeholder={"Find specific product by name or description"}
                    onChange={this.handleSearchTextChange}
                    prefix={<Icon source={SearchMinor} color="base" />}
                    autoComplete="off"
                />
                <Modal.Section>
                    <Stack alignment='center'>
                        <Stack.Item fill>
                            Selected products: {this.state.selectedProducts.length}
                        </Stack.Item>
                        <Stack.Item>
                            <Button plain onClick={this.handleClearSelected}>Clear Selected</Button>
                        </Stack.Item>
                    </Stack>
                </Modal.Section>
                <p><TextStyle variation="subdued">Showing the top 20 matching products ordered by date.</TextStyle></p>
                <ResourceList
                    resourceName={{ singular: 'product', plural: 'products' }}
                    items={this.props.products}
                    renderItem={this.renderResourceItem}
                />
            </Modal.Section>

        </Modal>
    }

    handleClearSelected = () => {
        this.setState({
            selectedProducts: []
        })
    }

    renderResourceItem = (item) => {
        const { id, title, legacyResourceId, image } = item;
        const isSelected = this.state.selectedProducts.filter(_ => _.id === id).length > 0;
        const buttonText = isSelected ? "Unselect" : "Select";

        return (
            <ResourceItem
                id={id}
                url={null}
                verticalAlignment="center"
                media={<Thumbnail source={image} alt="image" size="small" />}
                onClick={(e) => handleProductItemClick(e, legacyResourceId)}>
                <Stack alignment='center'>
                    <Stack.Item fill>
                        <TextStyle variation="strong">{title}</TextStyle>
                    </Stack.Item>
                    <Stack.Item>
                        <Button primary={!isSelected} onClick={(e) => this.handleClick(e, item)}>{buttonText}</Button>
                    </Stack.Item>
                </Stack>
            </ResourceItem>
        );
    }

    handleClick = (event, item) => {
        event.preventDefault();
        event.stopPropagation();

        const isSelected = this.state.selectedProducts.filter(_ => _.id === item.id).length > 0;

        if (!isSelected) {
            this.setState({
                selectedProducts: [...this.state.selectedProducts, item]
            })
        } else {
            var selectedIndex = this.state.selectedProducts.findIndex(_ => _.id === item.id);
            this.setState({
                selectedProducts: [
                    ...this.state.selectedProducts.slice(0, selectedIndex),
                    ...this.state.selectedProducts.slice(selectedIndex + 1)
                ]
            })
        }
    }

    handleSearchTextChange = (newText) => {
        this.setState({
            searchText: newText
        });

        this.props.onQueryProducts(newText);
    }

    onDone = () => {
        this.props.onDone(this.state.selectedProducts);
    }

    handleSelectedTagChange = (newSelected) => {
        this.setState({ selectedProducts: newSelected });
    }

    componentDidMount() {
        this.props.onQueryProducts("");
    }
}

export default SelectProductsModal;